import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=1d09c4ff&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
import style0 from "./alert.vue?vue&type=style&index=0&id=1d09c4ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d09c4ff",
  null
  
)

export default component.exports